<div class="modal-backdrop" (click)="onClose()"></div>
<div class="modal">
  <div class="modal-header">
    <h2>Invoice Details</h2>
    <span class="icon-btn" (click)="onClose()">
      <i class="fas fa-times"></i>
    </span>
  </div>
  <div class="modal-body">
    <div class="invoice-section">
      <h3><i class="fas fa-file-invoice" style="margin-right: 8px; color: #172a49;"></i>Invoice Information</h3>
      <div class="info-grid">
        <div class="info-item">
          <span class="label">Invoice Number:</span>
          <span class="value">{{invoice.invoice_id || invoice.invoice_number}}</span>
        </div>
        <div class="info-item">
          <span class="label">Status:</span>
          <span [class]="'badge ' + getStatusClass(invoice.payment_status || invoice.status)">
            {{(invoice.payment_status || invoice.status) | titlecase}}
          </span>
        </div>
        <div class="info-item">
          <span class="label">Order Date:</span>
          <span class="value">{{invoice.order_date || invoice.issue_date | date:'dd/MM/yyyy'}}</span>
        </div>
        <div class="info-item">
          <span class="label">Due Date:</span>
          <span class="value">{{invoice.due_date | date:'dd/MM/yyyy'}}</span>
        </div>
        <div class="info-item">
          <span class="label">Payment Type:</span>
          <span class="value">{{invoice.payment_type | titlecase}}</span>
        </div>
        <div class="info-item">
          <span class="label">Retailer:</span>
          <span class="value">{{invoice.retailer?.retailer_name || invoice.retailer_name}}</span>
        </div>
        <div class="info-item">
          <span class="label">Distributor:</span>
          <span class="value">{{invoice.distributor?.distributor_name || invoice.distributor_name}}</span>
        </div>
        <div class="info-item">
          <span class="label">Invoice Accepted:</span>
          <span class="value">{{invoice?.consent?.is_accepted ? 'Yes' : 'No'}}</span>
        </div>
        <div class="info-item">
          <span class="label">Created:</span>
          <span class="value">{{invoice.created_at | date:'dd/MM/yyyy, h:mm a'}}</span>
        </div>
      </div>
    </div>

    <div class="invoice-section" *ngIf="invoice.items && invoice.items.length > 0">
      <h3><i class="fas fa-shopping-cart" style="margin-right: 8px; color: #172a49;"></i>Items</h3>
      <div class="items-list">
        <div class="item-card" *ngFor="let item of invoice.items">
          <div class="item-left">
            <div class="item-name">{{item.name}}</div>
            <div class="item-details">Qty: {{item.qty}} × ₹{{item.rate | number: '1.0-0'}}</div>
          </div>
          <div class="item-right">
            <div class="item-total">₹{{item.total | number: '1.0-0'}}</div>
          </div>
        </div>
        <div class="items-total-row">
          <div class="items-total-label">Total</div>
          <div class="items-total-value">₹{{invoice.amount | number: '1.0-0'}}</div>
        </div>
      </div>
    </div>

    <div class="invoice-section">
      <h3><i class="fas fa-money-bill-wave" style="margin-right: 8px; color: #172a49;"></i>Payment Summary</h3>
      <div class="payment-summary">
        <div class="summary-row">
          <span class="label">Total Amount:</span>
          <span class="value">₹{{invoice.amount | number: '1.0-0'}}</span>
        </div>
        <div class="summary-row">
          <span class="label">Amount Paid:</span>
          <span class="value">₹{{invoice.amount_paid | number: '1.0-0'}}</span>
        </div>
        <div class="summary-row total">
          <span class="label">Balance Due:</span>
          <span class="value">₹{{getBalanceDue() | number: '1.0-0'}}</span>
        </div>
      </div>
    </div>

    <div class="invoice-section" *ngIf="invoice.img">
      <h3><i class="fas fa-paperclip" style="margin-right: 8px; color: #172a49;"></i>Attachment</h3>
      <div class="attachments">
        <a *ngIf="invoice.img" [href]="invoice.img" target="_blank" class="attachment-link">
          <i class="fas fa-image"></i> View Image
        </a>
      </div>
    </div>

    <!-- <div class="invoice-section">
      <h3><i class="fas fa-check-circle" style="margin-right: 8px; color: #172a49;"></i>Verification</h3>
      <div class="consent-info">
        <div class="consent-item">
          <i
            [class]="invoice.is_consent ? 'fas fa-check-circle consent-icon-success' : 'fas fa-times-circle consent-icon-error'"></i>
          <span>Customer Consent {{invoice.is_consent ? 'Obtained' : 'Not Obtained'}}</span>
        </div>
        <div class="consent-item">
          <i
            [class]="invoice.terms_and_conditions_accepted ? 'fas fa-check-circle consent-icon-success' : 'fas fa-times-circle consent-icon-error'"></i>
          <span>Terms & Conditions {{invoice.terms_and_conditions_accepted ? 'Accepted' : 'Not Accepted'}}</span>
        </div>
      </div>
    </div> -->
  </div>
  <div class="modal-footer">
    <button type="button" class="btn-secondary" (click)="onClose()">Close</button>
  </div>
</div>